<template>
  <li class="col-4" tabindex="0">
    <figure>
      <div class="box">
        <div class="content">
          <img class="image-responsive" :src="merch.image" alt="" />
        </div>
      </div>
      <div class="content-overlay" @click="openLink">
        <div class="content-details">
          <figcaption class="open-icon">
            <img src="../assets/open.svg" alt="" />
            <h2>{{ merch.title }}</h2>
            <h4>{{ merch.artist }}</h4>
          </figcaption>
        </div>
      </div>
      <figcaption class="mobile-info">
        <h2>{{ merch.title }}</h2>
        <h4>{{ merch.artist }}</h4>
        <div class="visit-shop">Visit Shop</div>
      </figcaption>
    </figure>
  </li>
</template>

<script>
export default {
  name: "MerchPreview",
  props: {
    merch: {
      type: Object,
    },
  },
  methods: {
    openLink() {
      this.trackEvent(
        "Landing Page",
        "Click",
        "Merch Preview",
        `${this.merch.artist}`
      );
      window.open(this.merch.link, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
li {
  visibility: visible;
  opacity: 1;
  transition: opacity 0.5s cubic-bezier(0.5, 0, 0, 1) 0s;
  padding: 8px;
  list-style-type: none;
  figure {
    width: 100%;
    height: 100%;
    position: relative;
    margin: auto;
    overflow: hidden;
    box-shadow: 1px 1px 16px -2px rgb(0 0 0 / 30%);
    display: block;
    .box {
      position: relative;
      width: 100%;
      .content {
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        .image-responsive {
          display: block;
          max-width: 100%;
          height: 100%;
          object-fit: cover;
          width: 100%;
        }
      }
    }
    .content-overlay {
      @media (max-size: 767px) {
        display: none;
      }
      transition: all 0.2s ease-in-out;
      background: rgba(0, 0, 0, 0.8);
      position: absolute;
      height: 100%;
      width: 100%;
      left: 0;
      top: 0;
      bottom: 0;
      right: 0;
      opacity: 0;
      cursor: pointer;
      @include on-hover {
        opacity: 1;
      }
    }
    .content-details {
      @media (max-size: 767px) {
        display: none;
      }
      transform: translate(-50%, -50%);
      transition: all 0.2s ease-in-out 0s;
      position: absolute;
      text-align: center;
      padding-left: 1em;
      padding-right: 1em;
      width: 100%;
      top: 50%;
      left: 50%;
      img {
        height: 20px;
        margin-bottom: 15px;
      }
      h2 {
        font-size: 16px;
        font-weight: 400;
        margin-bottom: 0;
        color: white;
        letter-spacing: -0.015em;
        line-height: 1.3;
        margin: 0.5em 0 0.25em;
      }
      h4 {
        font-size: 14px;
        color: #919496;
        font-weight: 400;
        margin: 0.5em 0 1em;
      }
    }
  }
}

.mobile-info {
  h2 {
    color: #919496;
    font-size: 18px;
    font-weight: 700;
    margin-top: 24px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-bottom: 0;
    cursor: pointer;
  }
  h4 {
    color: #c1c3c6;
    font-size: 16px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-bottom: 0;
    margin-top: 0.5em;
    cursor: pointer;
  }
  .visit-shop {
    color: #1db954;
    padding-left: 0;
    padding-right: 0;
    font-weight: 700;
    min-width: 0;
    font-size: 14px;
    line-height: 1;
    border-radius: 500px;
    padding: 16px 48px 18px;
    letter-spacing: 2px;
    text-transform: uppercase;
    white-space: normal;
  }
  display: block;
  @media (min-width: 768px) {
    display: none;
  }
}
</style>
